import configs from 'configs';
import { authHeaders } from 'functions/authHeader';
import request from 'functions/api/request';
import { questionnaireApi } from 'modules/questionnaire/api';
import { formatOptionsFromServerData } from 'components/Questionnaire/functions/formatOptionsFromServerData';
import { INTEGRATED_DISEASES } from 'utils/constants/disease';

const apiUrl = configs.beApiUrl;

export const getRandomQuotes = async () => {
  let response = null;

  const requestOptions = {
    url: `${apiUrl}/webappContent/random?type=quote&limit=1`,
    headers: await authHeaders(),
    json: true,
  };

  try {
    response = await request.get(requestOptions);
  } catch (ex) {
    console.error('Error occurred, while getting quotes', ex);
    throw ex;
  }

  return response?.data;
};

export const getDrugs = async (condition, additionalParams) => {
  if (INTEGRATED_DISEASES.includes(condition)) {
    return formatOptionsFromServerData([], 'drugs_received');
  }
  const result = await questionnaireApi.getDrugs(condition, additionalParams);
  return formatOptionsFromServerData(result, 'drugs_received');
};
